<template>
  <div>
    <h-table
        :data="acts"
        v-if="acts.length"
        row-key="label"
        :columns="columns"
        :pagination.sync="pagination"
        :rows-per-page-options="perPageOptions"
        :loading="actsLoading"
    >
      <q-td
          slot="body-cell-created_at"
          slot-scope="props"
          class="text-left"
      >
        {{ createdAt(props.row) }}
      </q-td>

      <q-td
          slot="body-cell-period"
          slot-scope="props"
          :class="`text-left ${parentComponentIsModal || props.row.count_documents <= 0 ? '' : 'documents-chain'}`"
          @click.native="$emit('openModal', props.row)"
      >
        {{ timePeriod(props.row) }}
      </q-td>

      <q-td
          slot="body-cell-name"
          slot-scope="props"
      >
        <a
            :href="`/${ '#' }`"
            target="_blank"
        >
          {{ props.value }}
        </a>
      </q-td>

      <q-td
          slot="body-cell-status"
          slot-scope="props"
          class="text-left"
      >
          <span :class="`status status--${getStatusAttributes(props.value).color}`">
              {{ getStatusAttributes(props.value).text }}
          </span>
      </q-td>

      <q-td
          slot="body-cell-source_vchasno"
          slot-scope="props"
          class="text-left"
      >
        <a
            v-if="props.value"
            :href="`${ props.value }`"
            target="_blank"
        >
          Перейти
        </a>
      </q-td>

      <q-td
          slot="body-cell-edit"
          slot-scope="props"
          class="text-right"
      >
        <div class="flex no-wrap justify-end">
          <q-btn
              @click="showActModal(props.row)"
              :disable="!canModify(props.row)"
              icon="description"
              color="tertiary"
              class="hover-positive"
              flat
              round
          >
            <q-tooltip
                :delay="500"
                :offset="[0, 5]"
            >
              Акт
            </q-tooltip>
          </q-btn>
          <q-btn
              @click="sendAct(props.row)"
              :disable="!props.row.project.payment_data.is_active_vchasno"
              :loading="props.row.sending"
              icon="send"
              color="tertiary"
              class="hover-primary"
              flat
              round
          >
            <q-tooltip
                :delay="500"
                :offset="[0, 5]"
            >
              {{ !props.row.project.payment_data.is_active_vchasno ? 'Вчасно не подключено' : 'Выгрузить во Вчасно' }}
            </q-tooltip>
          </q-btn>
          <q-btn
              v-if="canBatchUpload(props.row)"
              @click="uploadToVchasno(props.row)"
              :loading="props.row.batchSending"
              :disable="!canModify(props.row)"
              icon="publish"
              color="tertiary"
              class="hover-primary"
              flat
              round
          >
            <q-tooltip
                v-show="canModify(props.row)"
                :delay="500"
                :offset="[0, 5]"
            >
              Выгрузить все акты во Вчасно
            </q-tooltip>
          </q-btn>
          <q-btn
              @click="regenerateAct(props.row)"
              :loading="props.row.regenerating"
              :disable="!canModify(props.row)"
              icon="sync"
              color="tertiary"
              class="hover-primary"
              flat
              round
          >
            <q-tooltip
                v-show="canModify(props.row)"
                :delay="500"
                :offset="[0, 5]"
            >
              Перегенерировать
            </q-tooltip>
          </q-btn>
        </div>
      </q-td>
    </h-table>

    <act-modal
        v-if="actModalOpened"
        v-bind:bill="bill"
        v-bind:opened.sync="actModalOpened"
        :act-type="actType"
        :document="document"
    />
  </div>
</template>

<script>
import HTable from '@/HTable'

import columns from './mixins/columns'

import { date, QBtn, QTd, QTooltip } from 'quasar'

import ActsListModal from './ActsListModal'
import ActModal from '../BillsList/ActModal'

export default {
  name: 'ActsListTable',

  props: {
    acts: {
      type: Array,
    },
    actsLoading: {
      type: Boolean,
    },
  },

  components: {
    ActModal,
    ActsListModal,
    HTable,
    QBtn,
    QTooltip,
    QTd,
  },

  mixins: [
    columns,
  ],

  data () {
    return {
      perPageOptions: [10, 20, 40, 60],
      pagination: {
        page: 1,
        rowsPerPage: 20,
      },
      modalOpened: false,
      actModalOpened: false,
      billNumber: null,
      documentId: null,
      bill: null,
      actType: null,
      documentSending: false,
      document: {},
    }
  },

  methods: {
    regenerateAct (act) {
      if (!confirm('Перегенерировать этот акт?')) {
        return
      }

      act.regenerating = true
      this.$store.commit('project/setAct', act)
      this.$store.commit('project/setChainAct', act)

      this.$store.dispatch('project/regenerateAct', {
        projectId: this.$route.params.id,
        actId: act.id,
      }).then((response) => {
        if (response && response.hasOwnProperty('message')) {
          this.$q.notify({
            message: 'Акт успешно перегенерирован',
            type: 'positive',
          })

          this.$store.commit('project/setAct', response.document)
          this.$store.commit('project/setChainAct', response.document)
        }
        else {
          this.$q.notify({
            message: response.error,
            type: 'negative',
          })
        }
      })
    },

    canModify () {
      return this.$auth.user().role === 'root' || this.$auth.user().role === 'accountant'
    },

    showActModal (document) {
      this.bill = document.bill
      this.actModalOpened = true
      this.actType = document.type
      this.document = document
    },

    getStatusAttributes (status) {
      const statusAttributes = {
        0: { text: 'Не загружен во Вчасно', color: 'gray' },
        7000: { text: 'Загружен во Вчасно', color: 'gray' },
        7001: { text: 'Готов для подписи и отправки', color: 'orange' },
        7004: { text: 'Мы подписали, ждём контрагента', color: 'blue' },
        7006: { text: 'Отклонён контрагентом', color: 'red' },
        7008: { text: 'Полностью подписан', color: 'green' },
      }

      return statusAttributes[status]
    },

    sendAct (document) {
      document.sending = true
      this.$store.commit('project/setAct', document)
      this.$store.commit('project/setChainAct', document)

      this.$store.dispatch('project/sendAct', {
        projectId: document.project_id,
        documentId: document.id,
      }).then((response) => {
        if (response.status) {
          this.$q.notify({
            message: 'Документ успешно отправлен',
            type: 'positive',
          })

          document = response.document
          document.sending = false
          this.$store.commit('project/setAct', document)
          this.$store.commit('project/setChainAct', document)
        }
        else {
          this.$q.notify({
            message: 'Не удалось отправить документ',
            type: 'negative',
          })

          document.sending = false
          this.$store.commit('project/setAct', document)
          this.$store.commit('project/setChainAct', document)
        }
      })
    },

    timePeriod (row) {
      return row.startDate && row.endDate ?
             `${ date.formatDate(row.startDate, 'DD.MM.YYYY') } - ${ date.formatDate(row.endDate, 'DD.MM.YYYY') }`
                                          : null
    },

    createdAt (row) {
      return typeof row.updated_at === null ? row.created_at : row.updated_at
    },

    uploadToVchasno (document) {
      if (!confirm('Точно выгрузить все акты во Вчасно?')) {
        return
      }

      document.batchSending = true
      this.$store.commit('project/setAct', document)
      this.$store.commit('project/setChainAct', document)

      this.$store.dispatch('project/batchVchasnoUpload', {
        projectId: this.$route.params.id,
        document,
      })
    },

    canBatchUpload (document) {
      return document.count_documents > 1 && this.$parent.$options.name !== 'QModal'
    },
  },
}
</script>

<style lang="scss" scoped>
.documents-chain {
  cursor: pointer;
  color: #398EDD;
}

.status {
  position: relative;

  &::before {
    position: absolute;
    top: 4px;
    left: -15px;
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }

  &--gray::before {
    background: #888484;
  }

  &--orange::before {
    background: #FFAA00;
  }

  &--blue::before {
    background: #398EDD;
  }

  &--green::before {
    background: #1CD66B;
  }

  &--red::before {
    background: #E01515;
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ActsList/ActsListTable.vue